/**
 * App
 * contain code that should be seen on all pages. (e.g. navigation bar)
 * This component is the skeleton around the actual pages, and should only
 *
 */

import React from "react";
import { Helmet } from "react-helmet";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AppWorkspace, AppWrapper } from "./styles";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  defaultRedirection,
  isLoggedIn,
  getLoggedInUserLevel,
} from "utils/auth";
import GlobalStyle from "global-styles";
import { connect } from "react-redux";
import { compose } from "redux";
import injectReducer from "utils/injectReducer";
import injectSaga from "utils/injectSaga";
import { triggerLogout } from "./actions";
import {
  selectLogoutData,
  selectLoginData,
  selectVerifyData,
} from "./selectors";
import { createStructuredSelector } from "reselect";
import saga from "./sagas";
import reducer from "./reducer";
import Login from "screens/Auth/Login/Loadable";
import Verify from "screens/Auth/Verify/Loadable";
import MyNavbar from "components/MyNavbar";
import Consumer from "screens/Consumer/Loadable";
import Order from "screens/Order/Loadable";
import Queue from "screens/Queue/Loadable";
import Product from "screens/Product/Loadable";
import Print from "screens/Print/Loadable";
import Home from "screens/Home/Loadable";

import Dashboard from "screens/Dashboard/Loadable";
import User from "screens/Dashboard/User/Loadable";
import Statics from "screens/Dashboard/Statics/Loadable";
import Settings from "screens/Dashboard/Settings/Loadable";
import Buy from "screens/Buy/Loadable";
import OrderFlow from "screens/Buy/OrderFlow/Loadable";
import ReactGA from "react-ga";
import "../utils/i18n"; // YOUR_OWN_TRACKING_ID
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import QuickOrder from "screens/QuickOrder/Loadable";
import OrderChecker from "screens/OrderChecker/Loadable";
const TRACKING_ID = "UA-130237504-1";

function PrivateRoute({ children }) {
  if (!isLoggedIn()) return <Navigate to="/" replace />;
  return children;
}

function AppRoot(props) {
  ReactGA.initialize(TRACKING_ID);
  const firebaseConfig = {
    apiKey: "AIzaSyCOWXy7dblq8hz-6qXRMZiMFX7Eva47XmU",
    authDomain: "bakery-670d5.firebaseapp.com",
    projectId: "bakery-670d5",
    storageBucket: "bakery-670d5.appspot.com",
    messagingSenderId: "711498623478",
    appId: "1:711498623478:web:892bf2d65d5488a47affd7",
    measurementId: "G-YHS4S4SKR5",
  };

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  getAnalytics(app);

  const location = useLocation();
  const currentPathName = location.pathname !== "/";

  return (
    <AppWrapper>
      <Helmet
        titleTemplate="%s - Gorai Oven Delights"
        defaultTitle="Gorai Oven Delights"
      >
        <meta
          name="description"
          content="Best Bakery in Jamshedpur for baking christmas cakes, Order Online !"
        />
      </Helmet>
      {/* {!isLoggedIn() && <Redirect to="/" />} */}

      {isLoggedIn() && currentPathName && (
        <MyNavbar
          currentPathName={currentPathName}
          onLogout={props.triggerLogout}
          isLoggedIn={isLoggedIn()}
          userLevel={getLoggedInUserLevel()}
        />
      )}

      <AppWorkspace>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/verify" element={<Verify />} />

          {/* Protected routes */}
          <Route
            path="/user"
            element={
              <PrivateRoute>
                <User />
              </PrivateRoute>
            }
          />
          <Route
            path="/statics"
            element={
              <PrivateRoute>
                <Statics />
              </PrivateRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <Settings />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/consumer"
            element={
              <PrivateRoute>
                <Consumer />
              </PrivateRoute>
            }
          />
          <Route
            path="/order"
            element={
              <PrivateRoute>
                <Order />
              </PrivateRoute>
            }
          />
          <Route
            path="/queue"
            element={
              <PrivateRoute>
                <Queue />
              </PrivateRoute>
            }
          />
          <Route
            path="/product"
            element={
              <PrivateRoute>
                <Product />
              </PrivateRoute>
            }
          />
          <Route
            path="/print"
            element={
              <PrivateRoute>
                <Print />
              </PrivateRoute>
            }
          />
          <Route
            path="/buy/order"
            element={
              <PrivateRoute>
                <OrderFlow />
              </PrivateRoute>
            }
          />
          <Route
            path="/buy"
            element={
              <PrivateRoute>
                <Buy />
              </PrivateRoute>
            }
          />
          <Route
            path="/quick-order"
            element={
              <PrivateRoute>
                <QuickOrder />
              </PrivateRoute>
            }
          />
          <Route
            path="/order-checker"
            element={
              <PrivateRoute>
                <OrderChecker />
              </PrivateRoute>
            }
          />

          <Route path="*" element={<div>Not Found</div>} />
        </Routes>
        {defaultRedirection("root")}
        <ToastContainer />
      </AppWorkspace>

      <GlobalStyle />
    </AppWrapper>
  );
}

const mapStateToProps = createStructuredSelector({
  logoutData: selectLogoutData(),
  loginData: selectLoginData(),
  verifyData: selectVerifyData(),
});

function mapDispatchToProps(dispatch) {
  return {
    triggerLogout: (data) => {
      dispatch(triggerLogout(data));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withReducer = injectReducer({ key: "logout", reducer });
const withSaga = injectSaga({ key: "logout", saga });

export default compose(withReducer, withSaga, withConnect)(AppRoot);
